/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 12:05 PM
 */
import React, {Component} from 'react';
import Update from "./Update/Update";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {MDBDataTable} from "mdbreact";
import {Button as SementicBtn} from "semantic-ui-react";
import './ViewSysAdmin.css'
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    isUpdate: false,
    system_admin_data: null,
    data: []
  };
  handleUpdate = () => {
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  updateSysAdmin = (obj) => {
    this.handleUpdate();
    this.setState({
      system_admin_data: obj
    })
  };

  deleteSysAdmin = (id,name) => {
    swal({
      title:"Do you want to delete this system admin? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteSysAdmin_(id)
        }else{
          common.warningAlert("Can't delete system admin", 1)
        }
      });
  };

  deleteSysAdmin_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.SYSTEM_ADMIN_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System admin successfully deleted", 0);
          this.getData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteSysAdmin_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount(){
    this.getData();
  }

  getData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.SYSTEM_ADMIN, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.users
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    let rows = [];
    if(this.state.data.length !== 0){
      this.state.data.map((admin,index)=> {
        const obj= {
          email: admin.email,
          name: admin.fullName,
          username: admin.userName,
          added_by:admin.addedBy,
          added_datetime:common.convertDate(admin.addedDate),
          last_mod_by:admin.modifyBy !== null? admin.modifyBy : "-",
          last_mod_datetime:admin.modifyDate !== null? common.convertDate(admin.modifyDate) :"-",
          more:
          <div>
            <SementicBtn circular icon='edit' className={"more-update"}
                         onClick={() => this.updateSysAdmin(admin)}/>
            <SementicBtn circular icon='trash alternate' className={"more-remove"}
                         onClick={() => this.deleteSysAdmin(admin.userId,admin.userName)}/>

          </div>
        };
        rows.push(obj)
      })
    }
    let table_data = {columns, rows};

    return (
      <Row>
        {
          this.state.isUpdate ?
            <Update refreshData={this.getData} closeModal={this.handleUpdate} data={this.state.system_admin_data}/>
            : null
        }
        <Col lg="12">
          <Card>
            <CardHeader>
              System Administrators Details
            </CardHeader>
            <CardBody>
              <MDBDataTable
                id={"all-system-admin-table"}
                searching={true}
                searchLabel={"Search System Admin"}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                // striped={true}
                bordered
                hover
                data={table_data}/>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const columns = [
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Full Name',
    field: 'name',
    sort: 'asc'
  },
  {
    label: 'Username',
    field: 'username',
    sort: 'asc'
  },
  {
    label: 'Added By',
    field: 'added_by',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'added_datetime',
    sort: 'asc'
  },
  {
    label: 'Last Modified By',
    field: 'last_mod_by',
    sort: 'asc'
  },
  {
    label: 'Last Modified DateTime',
    field: 'last_mod_datetime',
    sort: 'asc'
  },
  {
    label: 'More Information',
    field: 'more',
    sort: 'asc'
  },
];

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
